<template>
  <div class="shadow-lg bg-white mb-4 lg:mx-1">
    <div class="tab__header">
      <a
        href="#"
        class="tab__link p-3 block bg-white no-underline text-white hover:text-white border-b-2 border-white flex justify-between"
        @click.prevent="active = !active"
      >
        <strong>{{title}}</strong>
        <span class="down-Arrow" v-show="!active">&#9660;</span>
        <span class="up-Arrow" v-show="active">&#9650;</span>
      </a>
    </div>
    <div :class="{ 'tab__content p-5 bg-white rounded-b-lg active' : active }" v-show="active">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: ["title"],
  data() {
    return {
      active: true
    };
  }
};
</script>

<style scoped>
.tab__link,
.tab__link:active,
.tab__link:hover,
.tab__link:focus {
  @apply text-purple-ap-100;
  outline: transparent;
  font-weight: 500;
}

.tab__content {
  opacity: 0;
  transition: all 0.3s;
}

.tab__content.active {
  transition: all 0.3s;
  opacity: 1;
}
</style>